import { VOLUME } from '../../constants.js';

export function volumeSpeaker(volume) {
  return {
    type: VOLUME.SPEAKER,
    volume: volume
  };
}

export function volumeMicrophone(volume) {
  return {
    type: VOLUME.MICROPHONE,
    volume: volume
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_volume.js